import React, { useState } from "react";
import { Button, Datagrid, DateField, ListContextProvider, TextField } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import HistoryIcon from "@mui/icons-material/History";
import { settings } from "app";
import { useNotifyError } from "utils/useNotifyError";

const FeesHistoryDialog = ({ id }) => {
  const notifyError = useNotifyError();
  const [feesHistory, setFeesHistory] = useState([]);

  const fetchFeesHistory = async () => {
    try {
      const { data } = await dataProvider.customRequest(specialistRequests.getSpecializationFeesHistory(id));
      setFeesHistory(data);
    } catch (err) {
      notifyError(err);
    }
  };

  return (
    <ConfirmModal
      dialogSize="md"
      onOpen={fetchFeesHistory}
      titleContent={"История на промените"}
      isConfirmButton={false}
      triggerButton={
        <Button
          label="История на промените"
          variant="contained"
          startIcon={<HistoryIcon />}
          sx={{ m: 2 }}
        />
      }
    >
      <ListContextProvider value={{ data: feesHistory }}>
        <Datagrid
          rowClick={false}
          bulkActionButtons={false}
          sx={{ margin: 2, ...settings.style.secondaryDatagrid }}
        >
          <DateField
            source="createdOn"
            label="Създаден на"
            locales="bg-BG"
          />
          <TextField
            source="practicalTrainingMonthlyFee"
            label="Месечна такса за практическо обучение"
          />
          <TextField
            source="practicalTrainingAnnualFee"
            label="Годишна такса за практическо обучение"
          />
          <TextField
            source="theoreticalTrainingMonthlyFee"
            label="Месечна такса за теоретично обучение"
          />
          <TextField
            source="theoreticalTrainingAnnualFee"
            label="Годишна такса за теоретично обучение"
          />
          <TextField
            source="stateExamFee"
            label="Такса за държавен изпит"
          />
        </Datagrid>
      </ListContextProvider>
    </ConfirmModal>
  );
};

export default FeesHistoryDialog;
